import { useState } from "react";
import { motion } from "framer-motion";
import { Play } from "lucide-react";
import { PortalTour } from "./PortalTour";

export const PortalShowcase = () => {
  const [tourOpen, setTourOpen] = useState(false);
  return (
  <section className="relative py-20 lg:py-28" data-testid="portal-showcase-section">
    <div className="mx-auto max-w-[1400px] px-6 lg:px-10">
      <motion.div
        initial={{ opacity: 0, y: 60 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-80px" }}
        transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1] }}
        className="group relative overflow-hidden border border-[#2A2D34] bg-[#0C0E11]"
        data-testid="case-study-portal"
      >
        <div className="grid grid-cols-1 lg:grid-cols-12">
          <div className="flex flex-col justify-center p-8 lg:col-span-5 lg:p-12">
            <p className="text-xs font-bold uppercase tracking-[0.3em] text-[#C6FF00]">
              Featured Build / Client Portal
            </p>
            <h3 className="mt-5 text-3xl lg:text-4xl font-black uppercase tracking-tight leading-[0.95]">
              Every client gets their own command center
            </h3>
            <p className="mt-5 text-[#C7CDD4] font-medium leading-relaxed">
              This isn't a mockup — it's the live portal every HughLaunch client
              logs into. Real-time project tracking, design approvals, brand
              asset uploads, billing and direct messaging, with an employee
              dashboard running the whole operation behind it.
            </p>
            <div className="mt-8 flex flex-wrap gap-x-8 gap-y-4">
              {[
                ["24/7", "Project visibility"],
                ["0", "Status-update emails"],
                ["1", "Place for everything"],
              ].map(([v, l]) => (
                <div key={l}>
                  <p className="text-3xl font-black text-[#C6FF00] tracking-tight lime-text-glow">{v}</p>
                  <p className="mt-1 text-xs text-white/70 font-semibold uppercase tracking-wider">{l}</p>
                </div>
              ))}
            </div>
            <motion.button
              whileHover={{ scale: 1.03 }}
              whileTap={{ scale: 0.97 }}
              transition={{ type: "spring", stiffness: 400, damping: 17 }}
              onClick={() => setTourOpen(true)}
              data-testid="portal-tour-open-btn"
              className="btn-shine mt-9 flex w-fit items-center gap-2.5 rounded-full bg-white px-6 py-3.5 text-xs font-bold uppercase tracking-wider text-[#0A0C0F] transition-colors duration-300 hover:bg-[#C6FF00]"
            >
              <Play className="h-3.5 w-3.5 fill-current" /> Take the Portal Tour
            </motion.button>
          </div>
          <div className="relative lg:col-span-7 p-6 pt-0 lg:p-10 lg:pl-0">
            <button
              onClick={() => setTourOpen(true)}
              data-testid="portal-tour-image-btn"
              aria-label="Open portal tour"
              className="block w-full cursor-pointer text-left overflow-hidden rounded-xl border border-white shadow-2xl transition-transform duration-700 ease-out group-hover:scale-[1.015]"
            >
              <div className="flex items-center gap-1.5 border-b border-[#2A2D34] bg-[#14171C] px-4 py-2.5">
                <span className="h-2.5 w-2.5 rounded-full bg-[#FF5F57]" />
                <span className="h-2.5 w-2.5 rounded-full bg-[#FEBC2E]" />
                <span className="h-2.5 w-2.5 rounded-full bg-[#28C840]" />
                <span className="ml-3 rounded-md bg-[#0A0C0F] px-3 py-0.5 text-[10px] font-semibold tracking-wide text-[#6B7280]">
                  portal.hughlaunch.com
                </span>
              </div>
              <img
                src="/portal-case.jpg"
                alt="HughLaunch client portal dashboard"
                loading="lazy"
                decoding="async"
                className="block w-full"
              />
            </button>
            <div className="pointer-events-none absolute -bottom-24 -right-20 h-64 w-64 rounded-full bg-[#C6FF00]/10 blur-3xl" aria-hidden="true" />
          </div>
        </div>
      </motion.div>
      <PortalTour open={tourOpen} onClose={() => setTourOpen(false)} />
    </div>
  </section>
  );
};
